<script setup>
import { computed, useAttrs } from 'vue'
import { useFormFieldContext } from '@/composables/useFormFieldContext'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  modelValue: { type: String, default: '' },
  id: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  invalid: { type: Boolean, default: null },
  density: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  rows: { type: [Number, String], default: 3 },
  ariaLabel: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])
const attrs = useAttrs()
const { resolveId, resolveDescribedby, resolveInvalid, resolveDensity } = useFormFieldContext()

const resolvedId = computed(() => resolveId(props.id))
const resolvedInvalid = computed(() => resolveInvalid(props.invalid))
const resolvedDensity = computed(() => resolveDensity(props.density))
const describedby = computed(() => resolveDescribedby(attrs['aria-describedby']))

const inputClass = computed(() => [
  'form-input',
  'form-textarea',
  resolvedDensity.value === 'compact' ? 'form-input--compact' : '',
  resolvedInvalid.value ? 'is-invalid' : '',
  attrs.class,
])
</script>

<template>
  <textarea
    :id="resolvedId"
    :value="modelValue"
    :disabled="disabled"
    :placeholder="placeholder"
    :rows="rows"
    :class="inputClass"
    :aria-invalid="resolvedInvalid ? true : undefined"
    :aria-describedby="describedby"
    :aria-label="ariaLabel || undefined"
    v-bind="{ ...attrs, class: undefined }"
    @input="$emit('update:modelValue', $event.target.value)"
  />
</template>
